import { Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { CommonModule } from '@angular/common';
import { V4MenuComponent } from '../menuV4/menu.component';
import { MenuComponent } from 'app/menu/menu.component';

@Component({
  selector: '[angly-header]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [ CommonModule, V4MenuComponent, MenuComponent ]
})
export class HeaderComponent implements OnInit {

  isV4Menu = false;

  constructor() {}

  ngOnInit() {
    this.isV4Menu = DataService.IS_V4_MENU_LAYOUT;
  }

}
